import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getDevices, selectDevice } from "./hostActionCreators";
import { Button, Icon, Menu } from "semantic-ui-react";

const deviceTypes = {
  COMPUTER: "Computer",
  SPEAKER: "Speaker",
  SMARTPHONE: "Smartphone",
  CHROMECAST: "CastVideo",
};

const getIconForDeviceType = (deviceType) => {
  switch (deviceType) {
    case deviceTypes.COMPUTER:
      return "computer";
    case deviceTypes.SPEAKER:
      return "volume up";
    case deviceTypes.SMARTPHONE:
      return "mobile";
    case deviceTypes.CHROMECAST:
      return "tv";
    default:
      return "";
  }
};

class DevicesMenu extends Component {
  constructor(props) {
    super(props);
    this.props.loadDevices();
    this.selectDevice = this.selectDevice.bind(this);
  }

  selectDevice(device) {
    this.props.selectDevice(device);

    this.props.onSelectSuccess && this.props.onSelectSuccess();
  }

  render() {
    return (
      <Menu vertical inverted fluid>
        {this.props.devices.map((device) => {
          return (
            <Menu.Item
              key={device.id || device.name}
              style={styles.menuItem}
              active={device.is_active}
            >
              <Menu.Header style={styles.menuItemHeaderActive}>
                <Icon name={getIconForDeviceType(device.type)} />
                {device.name}
              </Menu.Header>
              {device.is_active ? (
                <Button
                  style={{}}
                  content={"SELECTED"}
                  size={"tiny"}
                  basic
                  disabled
                  inverted
                />
              ) : (
                <Button
                  onClick={() => this.selectDevice(device)}
                  style={{}}
                  content={"SELECT"}
                  size={"tiny"}
                  basic
                  inverted
                />
              )}
            </Menu.Item>
          );
        })}
        <Menu.Item>
          {this.props.devices.length < 1 && (
            <Menu.Header
              as={"h5"}
              inverted="true"
              content={
                "Try to open Spotify on one of your devices so that Spotbox can start"
              }
            />
          )}
          <Button
            onClick={this.props.loadDevices}
            content={"REFRESH"}
            basic
            inverted
            size={"tiny"}
          />
        </Menu.Item>
      </Menu>
    );
  }
}

const styles = {
  menuItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  menuItemHeaderActive: {
    color: "green",
  },
};

const mapStateToProps = (state) => {
  return {
    devices: state.host.availableDevices,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectDevice: (device) => dispatch(selectDevice(device)),
    loadDevices: () => dispatch(getDevices()),
  };
};

DevicesMenu.propTypes = {
  devices: PropTypes.array.isRequired,
  selectDevice: PropTypes.func.isRequired,
  loadDevices: PropTypes.func.isRequired,
  onSelectSuccess: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DevicesMenu);
